import React, {Component} from 'react';
import {
  ResponsiveContainer, PieChart, Pie, Tooltip, Cell,
} from 'recharts';
import {colors} from '../../../../common/constants/colors';

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = (props) => {
  const {cx, cy, midAngle, outerRadius, percent, innerRadius} = props;

  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline='central'>
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

class PieChartInCpd extends Component {
  changeFillColor() {
    const {data} = this.props;
    return data.map((entry, index) => (
      <Cell key={index} fill={colors[index % colors.length]} />
    ));
  }

  render() {
    const {data, handleDrillDownByUser} = this.props;
    return (
      <ResponsiveContainer width='100%' height={510}>
        <PieChart>
          <Pie
            nameKey='label'
            dataKey='value'
            data={data}
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={180}
            fill='#8884d8'
            onClick={({name}) => handleDrillDownByUser(name)}
          >
            {this.changeFillColor()}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default PieChartInCpd;
